export const SET_IS_LOADING = 'filter/SET_IS_LOADING';
export const SET_FILTER_DATA = 'filter/SET_FILTER_DATA';
export const SET_DONE_LOADING = 'filter/SET_DONE_LOADING';
export const CLEAR_FILTER_DATA = 'filter/CLEAR_FILTER_DATA';
